/**
 * Normaliza comprobante(s) de un gasto a array de URLs.
 */
export function parseComprobantesGasto(comprobante) {
  if (!comprobante) return [];

  if (Array.isArray(comprobante)) {
    return comprobante.filter(Boolean);
  }

  if (typeof comprobante === 'string') {
    const trimmed = comprobante.trim();
    if (!trimmed) return [];
    if (trimmed.startsWith('[')) {
      try {
        const parsed = JSON.parse(trimmed);
        return Array.isArray(parsed) ? parsed.filter(Boolean) : [trimmed];
      } catch {
        return [trimmed];
      }
    }
    return [trimmed];
  }

  return [];
}

export function buildComprobanteGastoUrl(comprobanteUrl) {
  if (!comprobanteUrl) return '';
  if (comprobanteUrl.startsWith('http://') || comprobanteUrl.startsWith('https://')) {
    return comprobanteUrl;
  }

  const baseURL = process.env.REACT_APP_API_URL || 'http://localhost/backend';
  const base = baseURL.replace('/backend', '');

  if (comprobanteUrl.startsWith('/backend/')) {
    return base + comprobanteUrl;
  }
  if (comprobanteUrl.startsWith('/')) {
    return base + '/backend' + comprobanteUrl;
  }
  return base + '/backend/uploads/gastos/' + comprobanteUrl;
}
